import { useNuxtApp } from '#app'

export const useI18n = () => {
    const { $t } = useNuxtApp()
    return { t: $t }
}
